module.exports = __webpack_public_path__ + "img/cropper-test.a4c08dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cropper-test.png
// module id = g5O9
// module chunks = 249